import React from 'react';
import './_resume.scss';

const ResumeEducation = () => (
  <section className="resume--section">
    <h1 className="resume--section-title">Education</h1>
    <div className="rb-experience-item">
      <div>
        <div>1993</div>
        <div className="resume--section--block-title">BACHELOR OF SCIENCE</div>
        <div className="resume--section--block-subtitle">Mechanical Engineering</div>
      </div>
      <div className="resume--section--block-content">Worcester Polytechnic Institute</div>
    </div>
  </section>
);

export default ResumeEducation;



// WEBPACK FOOTER //
// ./src/pages/resume/_Education.js